export default state => {
	return state.auth.isAuthenticated === null;
};
